import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProductsAndUpdateInnerLights } from 'rangeConfig/pax/utils/removeProducts';
import { ProductType } from '@inter-ikea-storageone/range';

const deleteProduct = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  const selectedProductType = coreApi.entities.getProductType(selectedEntity);

  if (
    selectedProductType === ProductType.PAX_FRAME ||
    selectedProductType === ProductType.PAX_SLIDING_DOOR_REGULAR_ASM ||
    selectedProductType === ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
  ) {
    removeProductsAndUpdateInnerLights([selectedEntity], coreApi);
  } else {
    coreApi.entities.delete(selectedEntity);
  }
};

export default deleteProduct;
